import axios from "axios";

// Prefer env-driven base URL to keep dev/prod aligned
export const baseURL = "https://sakthiapi.mapsapp.in";
// export const baseURL = "http://localhost:4002";

// Create an instance of axios
const axiosInstance = axios.create({
  baseURL,
});
// Use interceptor to dynamically update auth token and other headers
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const authTokens = localStorage.getItem("token"); // Ensure correct key
      const userId = localStorage.getItem("userId");
      const role = localStorage.getItem("role");

      if (authTokens) config.headers["auth-token"] = authTokens;
      if (userId) config.headers["userId"] = userId;
      if (role) config.headers["role"] = role;

      return config;
    } catch (error) {
      console.error("🚨 Axios Request Interceptor Error:", error);
      return config;
    }
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();
      // localStorage.setItem("extension", "approved");

      if (window.location.pathname !== "/") {
        window.location.assign("/"); // still one redirect, but only once
      }
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
